import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {ApplicationConfig} from "@angular/core";
import {provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling} from "@angular/router";
import {appRoutes} from "./app.routes";
import {authInterceptor} from "@/interceptors/auth-interceptor";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import Aura from "@primeuix/themes/aura";
import {API_BASE_URL, Client} from '@/api/client';
import {environment} from "@/environment/environment";
import {MessageService} from "primeng/api";


export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()), Client,
        MessageService,
        provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
        provideAnimationsAsync(),
        {
            provide: API_BASE_URL,
            useValue: environment.apiUrl
        },
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } })
    ]
};
